import { Box, Grid } from '@chakra-ui/react';
import { useTranslate } from '@tolgee/react';
import { COMMON_COLORS } from './common-color';

interface ColorPickerProps {
  selectedColor: string;
  onColorSelect: (color: string) => void;
}

export function ColorPicker({ selectedColor, onColorSelect }: ColorPickerProps) {
  const { t } = useTranslate();

  return (
    <Grid templateColumns="repeat(3, 1fr)" gap={2}>
      {COMMON_COLORS.map((color) => (
        <Box
          key={color}
          w="20"
          h="40px"
          bgColor={color}
          border={selectedColor == color ? '4px solid' : '2px solid'}
          borderColor={selectedColor === color ? 'blue.500' : 'gray.200'}
          borderRadius="md"
          cursor="pointer"
          onClick={() => {
            onColorSelect(color);
          }}
          _hover={{
            transform: 'scale(1.05)',
            boxShadow: '0 0 0 2px var(--chakra-colors-blue-500)',
            transition: 'all 0.2s',
          }}
          aria-label={t('top-banner.color-picker.select-color', 'Select color')}
        />
      ))}
    </Grid>
  );
}
